const Util = {
	/**
	*  check el is in view
	* @return {Boolean} el is in view
	*/
	checkInView: function(dom) {
	  const rect = dom.getBoundingClientRect()

	  return (rect.top < window.innerHeight && rect.bottom > 0) &&
	      (rect.left < window.innerWidth && rect.right > 0)
	}
}
module.exports = Util


// WEBPACK FOOTER //
// ./~/@dp/util-m-view-push/src/util.js